import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'

export const ConfirmationPopup = ({
  confirmLabel,
  onClose,
  isOpen,
  title,
  isLoading,
  onConfirm,
  children
}) => (
  <Popup
    title={title}
    isOpen={isOpen}
    onClose={onClose}
  >
    <Body>
      {children}
    </Body>
    <Footer>
      <Button
        onClick={onClose}
        decoration="secondary-outline"
      >
        {I18n.t('publisher.action.cancel')}
      </Button>
      <Button
        onClick={onConfirm}
        loading={isLoading}
      >
        {confirmLabel}
      </Button>
    </Footer>
  </Popup>
)
